import React, { Fragment } from 'react';
import { SectionHeader } from '../ui/Shared';
export function HowItWorksSection() {
  const steps = [{
    title: 'Reducir el ardor',
    desc: 'Menos sensación de fuego en pecho y garganta.'
  }, {
    title: 'Dormir mejor',
    desc: 'Menos subida de ácido durante la noche.'
  }, {
    title: 'Comer con más tranquilidad',
    desc: 'Saber qué evitar y qué sí puedes comer.'
  }];
  return <section id="como-funciona" className="py-24" data-id="element-248">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-249">
        <SectionHeader tag="Qué puedes esperar" title={<>
              3 resultados que
              <br data-id="element-251" />
              notarás
            </>} data-id="element-250" />

        <div className="stagger-children mt-12" data-id="element-252">
          {steps.map((step, idx) => <Fragment key={idx} data-id="element-253">
              <div className="flex flex-col md:flex-row gap-4 md:gap-7 mb-8 md:mb-12 items-start" data-id="element-254">
                <div className="w-11 h-11 md:w-14 md:h-14 bg-gradient-gold rounded-full flex items-center justify-center font-playfair text-xl md:text-2xl font-black text-primary shrink-0" data-id="element-255">
                  {idx + 1}
                </div>
                <div className="mt-1 md:mt-0" data-id="element-256">
                  <h3 className="text-xl font-bold mb-2 text-text-light" data-id="element-257">
                    {step.title}
                  </h3>
                  <p className="text-base text-text-muted leading-relaxed" data-id="element-258">
                    {step.desc}
                  </p>
                </div>
              </div>
              {idx < steps.length - 1 && <div className="w-0.5 h-8 bg-gradient-to-b from-accent to-transparent ml-[21px] md:ml-[27px] -mt-4 mb-4 md:mb-0 hidden md:block" data-id="element-259" />}
            </Fragment>)}
        </div>
      </div>
    </section>;
}